module.exports = __webpack_public_path__ + "img/custom.76688b0d.png";